import axios from "axios";
import CareerPageData from "../Data/CareerPage(Content31).json";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchCareerPage = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/career`, {
      timeout: 10000,
    });
    const payload = response.data?.data || response.data;

    if (!payload || response.data?.code >= 400) {
      throw new Error("Invalid career API response");
    }

    return payload;
  } catch (error) {
    console.warn(
      "Career API unavailable, using local JSON fallback:",
      error.message,
    );
    return CareerPageData;
  }
};

export const uploadCareerPage = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/career/upload`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const fetchCareerPositions = async () => {
  const response = await axios.get(`${API_BASE_URL}/career/positions`);
  return response.data?.items || [];
};

export const createCareerPosition = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/career/positions`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const updateCareerPosition = async (positionId, payload) => {
  const response = await axios.put(
    `${API_BASE_URL}/career/positions/${positionId}`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const deleteCareerPosition = async (positionId) => {
  await axios.delete(
    `${API_BASE_URL}/career/positions/${positionId}`,
    getAuthConfig(),
  );
};

export const applyToCareerPosition = async (positionId, payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/career/positions/${positionId}/apply`,
    payload,
  );

  return response.data;
};

export const fetchCareerApplications = async (positionId) => {
  const params = positionId ? { positionId } : undefined;
  const response = await axios.get(`${API_BASE_URL}/career/applications`, {
    ...getAuthConfig(),
    params,
  });

  return response.data?.items || [];
};
